import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { PARKING_DOWNTIME_48H_GRADIENT_LEGEND } from '../../../constants/legends';

const ParkingDowntime48hComponent = () => (
    <LegendRenderer config={PARKING_DOWNTIME_48H_GRADIENT_LEGEND} />
);

export const ParkingDowntime48hLegend = withDisplayedLayersCheck(ParkingDowntime48hComponent, t`Простой самокатов (48+ ч)`);
